import React, { useContext, useState } from 'react';
import "../../css/Form.css"
import { AlertContext } from '../../AlertContext';

const DeleteForm = ({apiUrl}) => {
  const {showAlert} = useContext(AlertContext)

  const [formData, setFormData] = useState({
    customerId: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${apiUrl}/dashboard/customer/delete/${formData.customerId}`, {
        method: 'DELETE',
      });
  
      if (response.status === 204) {
        showAlert("Deleted Customer Successfully","success");
        // Reset form fields after successful deletion
        setFormData({
          customerId: ''
        });
      } else {
        showAlert("Error deleting customer","danger");
      }
    } catch (error) {
      console.error('Error deleting customer:', error);
    }
  };
  
  

  return (
    <div className="container">
      <h3>Delete Customer</h3>
      <form onSubmit={handleSubmit} className="form">
        <div className="form-field">
          <label htmlFor="customerId">Customer Id:</label>
          <input type="text" name="customerId" value={formData.customerId} onChange={handleChange} />
        </div>
        <div className="button">
          <button type="submit" className="btn btn-danger">Delete</button>
        </div>
      </form>
    </div>
  );
};

export default DeleteForm;
